<template>
	<Container>
		<Title>
			{{ $t('Bonos') }}
		</Title>

		<div class="grid" v-if="bonuses">
			<Card
				v-for="(bonuses_item, bonuses_index) in bonuses"
				v-bind:key="bonuses_index"
			>
				<div class="flex justify-center">
					<img
						v-if="bonuses_item.image"
						:src="bonuses_item.image"
						class="img_bonus"
					/>
					<img v-else :src="bonuses_item.company_image" class="img_bonus" />
				</div>
				<div class="text-center">
					<h2
						class="text-lg block font-semibold mt-6 mb-3"
						:style="`color:${bonuses_item.company_style}`"
					>
						{{ bonuses_item.title }}
					</h2>
					<div v-html="bonuses_item.body"></div>
					<div class="mt-5">
						<span class="block text-sm">{{ $t('bonus_text') }}:</span>
						<span class="block text-sm">{{
							bonuses_item.valid_until | moment('DD/MM/YYYY')
						}}</span>
					</div>
				</div>
			</Card>
		</div>
		<div v-else>{{ $t('not_found_bonuses') }}.</div>
	</Container>
</template>

<script>
import gql from 'graphql-tag'

export default {
	apollo: {
		bonuses: {
			query: gql`
				query ($country_id: bigint!) {
					bonuses(
						where: { country_id: { _eq: $country_id }, active: { _eq: true } }
						order_by: { valid_until: asc }
					) {
						id
						title
						body
						valid_until
						image {
							url
						}
						company {
							image {
								url
							}
							style
						}
					}
				}
			`,
			variables() {
				return {
					country_id: this.country_id
				}
			},
			update(data) {
				return data.bonuses.map(item => {
					const image =
						item.image && item.image.url
							? `${
									process.env.VUE_APP_API_URL
							  }/public/assets/images/?key=${item.image.url.slice(
									1
							  )}&width=400`
							: undefined

					const company_image =
						item.company.image && item.company.image.url
							? `${
									process.env.VUE_APP_API_URL
							  }/public/assets/images/?key=${item.company.image.url.slice(
									1
							  )}&width=400`
							: undefined

					return {
						id: item.id,
						title: item.title,
						body: item.body,
						valid_until: item.valid_until,
						image: image,
						company_image: company_image,
						company_style: item.company.syle
					}
				})
			}
		}
	},
	data() {
		return {
			country_id: this.$store.state.login.user.country_id
		}
	}
}
</script>
<style scoped>
.img_bonus {
	height: 90px !important;
}
</style>
